import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-list-page-layout-header',
  templateUrl: './list-page-layout-header.component.html',
  styleUrls: ['./list-page-layout-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListPageLayoutHeaderComponent {}
